var map = {
	"./Oxxo_Logo.svg.webp": 970,
	"./PREPA-EN-LINEA.png": 906,
	"./barber-PALO-ALTO-20250817.png": 860,
	"./barber-pinos-20250714.png": 160,
	"./barber-pinos.jpeg": 675,
	"./barber.jpg": 206,
	"./barberia-paloAlto.jpeg": 166,
	"./enf-pinos.jpeg": 300,
	"./enfermeria-PaloAlto.jpg": 259,
	"./enfermeria.jpg": 102,
	"./estilismo-paloAlto.jpg": 982,
	"./estilismo-pinos.jpeg": 562,
	"./estilismo.jpg": 305,
	"./icon-barbershop.jpg": 228,
	"./icon-estilismo.jpg": 827,
	"./icon-nurse.jpg": 539,
	"./icon-prepa - copia.jpg": 15,
	"./icon-prepa.avif": 646,
	"./icon-prepa.jpg": 442,
	"./iconEnglish.png": 31,
	"./iconIteci.png": 103,
	"./ingles.jpg": 488,
	"./iteci-logo.jpeg": 793,
	"./iteci-talte-enf.jpeg": 198,
	"./iteci.png": 194,
	"./loading.jpg": 526,
	"./loading.png": 474,
	"./loading2.jpg": 478,
	"./prepa-EN-LINEA2.png": 522,
	"./prepa-palo-alto-20250907.jpeg": 157,
	"./prepa-pinos.jpeg": 517,
	"./prepa.jpeg": 473,
	"./roulette.jpg": 576,
	"./unias.jpg": 640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;